import { render, staticRenderFns } from "./PictureCapture.vue?vue&type=template&id=5a3e2298&"
import script from "./PictureCapture.vue?vue&type=script&lang=js&"
export * from "./PictureCapture.vue?vue&type=script&lang=js&"
import style0 from "./PictureCapture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3e2298')) {
      api.createRecord('5a3e2298', component.options)
    } else {
      api.reload('5a3e2298', component.options)
    }
    module.hot.accept("./PictureCapture.vue?vue&type=template&id=5a3e2298&", function () {
      api.rerender('5a3e2298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PictureCapture.vue"
export default component.exports